import styled, { keyframes, css } from 'styled-components';

export const ProjectSectionContainer = styled.div`
  text-align: left;
  /* max-width: calc(3 * 350px + 3 * 30px); */
  max-width: 1140px;
  margin: 0 auto;
  min-height: calc(500px);

  .carouselReaction {
    margin: 0 auto;
    @media(min-width: 761px) {
      display: none;
    }
  }

  .gridReaction {
    @media(max-width: 760px) {
      display: none;
    }
  }
`;

export const ProjectTechnologyIcon = styled.div`
  display: inline;
  height: 30px;
  width: 30px;
  color: white;
  margin-left: 10px;
`;

// not a link because the links associated with projects
// can be within the app, or external
export const ProjectLinkWrapper = styled.a`
  text-decoration: none;
  color: inherit;
`;
 
export const ProjectCardDiv = styled.div`
  position: relative;

  height: 100%;
  width: 100%;
  margin: 15px auto;
  width: 350px;
  background-image:
  linear-gradient(to top, #000, rgba(0,0,0,0)),
    ${(props) => `url(${props.background})`};
  background-position: center;
  background-size: cover;
  border-radius: 5px;
  transition: 0.2s all ease-in-out;
  &:hover {
    transform: translate(0px, -5px); 
  }
`;

// this div is the main content container that sets the height and width of the card
export const ProjectContentContainer = styled.div`
  width: 350px;
  height: 400px;
  border-radius: 5px;
  transition: 0.2s all ease-in-out;

  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.6);
  }
  
`;

export const ProjectCardContent = styled.div`
  position: absolute;
  bottom: 0;
  border-radius: 5px;
`;

export const ProjectCardHeader = styled.h1`
  font-size: 25px;
`;


const popAnimation = keyframes`
  40% {
    transform: scale(1.25, 0.8);
  }

	50% {
		transform: scale(0.8, 1.25);
  }

	60% {
		transform: scale(1.15, 1);
  }

	70% {
		transform: scale(1.2, 1.2);
  }

	100% {
		transform: scale(1.2, 1.2);
  }
`;
/**
 * Radio Buttons styled like nice divs :)
 */

export const ProjectTypeButton = styled.button`
  background: ${(props) => props.selected ? (props.projectType === 'Personal' ? '#94D1FE' : '#FFCC00') : '#424242'};
  color : ${(props) => props.selected ? 'black' : 'white'};
  height: 40px; 
  width: 100px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  margin: 20px;

  border-radius: 5px;
  /* Border none for weird chrome mobile glitch */
  border: none;
  transition: 0.3s all ease-in-out;
  transform: scale(${(props) => props.selected ? 1.2 : 1});

  /**Injects animation css based on selected property */
  ${({ selected }) => selected && css`
    animation: ${popAnimation} 1s ease-in;
    animation-iteration-count: 1;
    transition-delay : 0.3s;
  `}

  &:hover {
    cursor: pointer;
    transform: scale(1.2); 
  }
`;